import React, { ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IPartner } from '@/modules/partner/model';
import { DescriptionList } from '@/shared/view/DescriptionList';

import s from './styles.module.css';

interface IProps {
  children: ReactNode;
  partner: IPartner;
  onClickEdit: () => void;
  className?: string;
}

const ContactInfo = ({ children, partner, onClickEdit, className }: IProps) => {
  const intl = useIntl();

  const titles = useMemo(
    (): Array<['email' | 'phone', string]> => [
      [
        'phone',
        intl.formatMessage({
          defaultMessage: 'Phone',
          id: 'nRHsAq',
          description: 'Profile screen: contact info section',
        }),
      ],
      [
        'email',
        intl.formatMessage({
          defaultMessage: 'Email',
          id: 'RNNpvw',
          description: 'Profile screen: contact info section',
        }),
      ],
    ],
    [intl],
  );

  return (
    <DescriptionList
      className={className}
      title={intl.formatMessage({
        defaultMessage: 'Contact information',
        id: 'L0ST1R',
        description: 'Profile screen: subheader',
      })}
      values={partner}
      titles={titles}
      action={
        <span onClick={onClickEdit} className={s.editButton}>
          {intl.formatMessage({
            defaultMessage: 'Edit',
            id: 'global_action_edit',
            description: 'Profile screen: button text',
          })}
        </span>
      }
    >
      {children}
    </DescriptionList>
  );
};

export { ContactInfo };
